module.exports = __webpack_public_path__ + "static/media/curate_black.af8b7abc.svg";